// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-actions-__id-indexstyleGrid-container-boetp{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.pages-actions-__id-indexstyleGrid-grid-bgpbt{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-actions-__id-indexstyleGrid-col6-rvqfx{grid-column:span 6}.pages-actions-__id-indexstyleGrid-col3-bznuu{grid-column:span 3}.pages-actions-__id-indexstyleGrid-col4-bbyfi{grid-column:span 4}.pages-actions-__id-indexstyleGrid-col9-vayho{grid-column:span 9}.pages-actions-__id-indexstyleGrid-col12-boiul{grid-column:span 12}.pages-actions-__id-indexstyleGrid-alignItemsStart-bqpdj{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-actions-__id-indexstyleGrid-container-boetp",
	"grid": "pages-actions-__id-indexstyleGrid-grid-bgpbt",
	"col6": "pages-actions-__id-indexstyleGrid-col6-rvqfx",
	"col3": "pages-actions-__id-indexstyleGrid-col3-bznuu",
	"col4": "pages-actions-__id-indexstyleGrid-col4-bbyfi",
	"col9": "pages-actions-__id-indexstyleGrid-col9-vayho",
	"col12": "pages-actions-__id-indexstyleGrid-col12-boiul",
	"alignItemsStart": "pages-actions-__id-indexstyleGrid-alignItemsStart-bqpdj"
};
module.exports = ___CSS_LOADER_EXPORT___;
